<template>
	<div id='StripLogos'>
		<b-container>
			<b-row>
				<b-col sm=12 md=3 class="boxLogos">
					<a href="https://www1.folha.uol.com.br/mercado/2018/01/1954550-start-ups-financeiras-crescem-em-setores-como-emprestimo-e-poupanca.shtml">
                     <img loading="lazy" width="214" height="23" class="folha" src="../../assets/svg/folha-de-s-paulo.svg" alt="folha de são paulo">
                     </a>
				</b-col>
				<b-col sm=12 md=3 class="boxLogos">
					<a href="https://valor.globo.com/financas/noticia/2017/12/01/bb-seguridade-e-principal-criam-plataforma-digital-para-previdencia-1.ghtml">
                    <img loading="lazy" width="112" height="38" class="valor" src="../../assets/svg/g-8.svg" alt="">
                     </a>
				</b-col>
				<b-col sm=12 md=3 class="boxLogos">
					<a href="https://fintechlab.com.br/index.php/2017/12/07/fintech-de-previdencia-ciclic-quer-garantir-planos-de-vida-para-2-5-ou-20-anos/">
                  <img loading="lazy" width="112" height="62" class="fintech" src="https://ciclic.imgix.net/devices/home-images/fintech.png?auto=compress,format&h=62" alt="">
                     </a>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
	import './StripLogos.css'
	export default {
		name: 'StripLogos'
	}
</script>
